import React from 'react'
import { PropTypes } from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class BodyView extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    static propTypes = {
        schedulerData: PropTypes.object.isRequired,
    }

    render() {
        const { schedulerData, singleResourceView, weeklyHoursTotalsAndEmploymentPercent, t, userWorkHoursRuleByDepartment, dateTimeRules, isMainRosterScheduler } = this.props;
        const { renderData, headers, config, behaviors, localeMoment } = schedulerData;
        let cellWidth = schedulerData.getContentCellWidth();
        let currentWeek = null;
        let weekHeaderList = [];

        let displayRenderData = renderData.filter(o => o.render);
        let tableRows = displayRenderData.map((item) => {
            let rowCells = headers.map((header, index) => {
                const getDay = localeMoment(header.time).day();
                const isSatSun = getDay === 0 || getDay === 6;
                let key = item.slotId + '_' + header.time;
                let style = index === headers.length - 1 ? {} : { width: cellWidth };
                if (isSatSun)
                    style = { ...style, backgroundColor: config.nonWorkingTimeBodyBgColor };
                if (item.groupOnly)
                    style = { ...style, backgroundColor: config.groupOnlySlotColor };
                if (!!behaviors.getNonAgendaViewBodyCellBgColorFunc) {
                    let cellBgColor = behaviors.getNonAgendaViewBodyCellBgColorFunc(schedulerData, item.slotId, header);
                    if (!!cellBgColor)
                        style = { ...style, backgroundColor: cellBgColor };
                }

                if (singleResourceView) {
                    let datetime = localeMoment(header?.time);
                    const week = datetime.isoWeek();

                    if (!currentWeek || currentWeek.week !== week) {
                        if (currentWeek) {
                            const totalWeeklyHours = ((weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekHours || 0) / 60).toFixed(dateTimeRules.decimal_places || 2)
                            weekHeaderList.push(
                                <th
                                    key={`week-${currentWeek.week}-${index}`}
                                    colSpan={currentWeek.colspan}
                                    title={`${t('Employment')} ${weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekEmpPercent || 0}% | ${t('Total')} ${totalWeeklyHours || 0} ${t('hr')}`}
                                    style={{
                                        textAlign: 'center',
                                        backgroundColor: '#daddce',
                                        border: '1px solid #e9e9e9',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '30px',
                                    }}
                                >
                                    {`${t('Employment')} ${weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekEmpPercent || 0}% | ${t('Total')} ${totalWeeklyHours || 0} ${t('hr')}`}
                                    {((weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekHours / 60) > (userWorkHoursRuleByDepartment.mandatory_overtime_limit_per_week / 60)) &&
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    {t('Exceeds max hours limit')} {(userWorkHoursRuleByDepartment.mandatory_overtime_limit_per_week / 60)} {t('hrs')}
                                                </Tooltip>
                                            }
                                        >
                                            <i className="ms-2 fas fa-exclamation text-danger"></i>
                                        </OverlayTrigger>
                                    }
                                </th>
                            );
                        }

                        currentWeek = {
                            week,
                            start: datetime.format('DD.MM.YYYY'),
                            colspan: 1
                        };
                    } else {
                        currentWeek.colspan += 1;
                    }
                }

                return (
                    <td key={key} style={style}>
                        <>
                            {isMainRosterScheduler && getDay === 0 ?
                                <div className='fs10 text-body-secondary fw-600'>F1</div> : isMainRosterScheduler && getDay === 6 ? <div className='fs10 text-body-secondary fw-600'>F2</div> : <div></div>}
                        </>
                    </td>
                )
            });

            if (singleResourceView && currentWeek) {
                weekHeaderList.push(
                    <th
                        key={`week-${currentWeek.week}-last`}
                        colSpan={currentWeek.colspan}
                        title={`${t('Employment')} ${weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekEmpPercent || 0}% | ${t('Total')} ${(weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekHours / 60 || 0).toFixed(dateTimeRules.decimal_places || 2)} ${t('hr')}`}
                        style={{
                            textAlign: 'center',
                            backgroundColor: '#daddce',
                            border: '1px solid #e9e9e9',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            maxWidth: '30px'
                        }}
                    >
                        {`${t('Employment')} ${weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekEmpPercent || 0}% | ${t('Total')} ${(weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekHours / 60 || 0).toFixed(dateTimeRules.decimal_places || 2)} ${t('hr')}`}
                        {((weeklyHoursTotalsAndEmploymentPercent[currentWeek.week]?.weekHours / 60) > (userWorkHoursRuleByDepartment.mandatory_overtime_limit_per_week / 60)) &&
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t('Exceeds max hours limit')} {(userWorkHoursRuleByDepartment.mandatory_overtime_limit_per_week / 60)} {t('hrs')}
                                    </Tooltip>
                                }
                            >
                                <i className="ms-2 fas fa-exclamation text-danger"></i>
                            </OverlayTrigger>
                        }
                    </th>
                );
            }

            return (
                <tr key={item.slotId} style={{ height: item.rowHeight }}>
                    {rowCells}
                </tr>
            );
        });

        return (
            <tbody>
                {tableRows}
                {singleResourceView &&
                    <tr key={'details'} style={{ height: '30px' }}>
                        {weekHeaderList}
                    </tr>
                }
            </tbody>
        );
    }
}

export default BodyView;